module.exports = __webpack_public_path__ + "static/img/cp_gc_logo.5eb42f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/index/cp_gc_logo.png
// module id = 1D06
// module chunks = 0